import { Routes } from '@angular/router';
import { InicioComponent } from './paginas/inicio/inicio.component';
import { CloudComponent } from './paginas/cloud/cloud.component';
import { HostingComponent } from './paginas/hosting/hosting.component';
import { DomainComponent } from './paginas/domain/domain.component';
import { FaqComponentComponent } from './paginas/faq-component/faq-component.component';
import { TermsComponent } from './terms/terms.component';
import { PoliticasComponent } from './politicas/politicas.component';
import { RedeComponent } from './paginas/rede/rede.component';
import { SobreComponent } from './paginas/sobre/sobre.component';
import { ServicosPageComponent } from './paginas/servicos/servicos.component';
import { ProdutosComponent } from './paginas/produtos/produtos.component';
import { CookiesComponent } from './cookies/cookies.component';
import { EmailCorporativoComponent } from './paginas/email-corporativo/email-corporativo.component';
import { PrivateCloudComponent } from './paginas/private-cloud/private-cloud.component';

export const routes: Routes = [
    { path: '', component: InicioComponent },
    { path: 'cloud', component: CloudComponent },
    { path: 'hosting', component: HostingComponent },
    { path: 'domain', component: DomainComponent },
    { path: 'faq', component: FaqComponentComponent },
    { path: 'termos-condicoes', component: TermsComponent },
    { path: 'politicas', component: PoliticasComponent },
    { path: 'politica-de-cookies', component: CookiesComponent },
    { path: 'noadsvpn', component: RedeComponent },
    { path: 'sobre-nos', component: SobreComponent },
    { path: 'servicos', component: ServicosPageComponent },
    { path: 'produtos', component: ProdutosComponent },
    { path: 'email-corporativo', component: EmailCorporativoComponent },
    { path: 'private-cloud', component: PrivateCloudComponent }
];
